// Handy-Fotos vor dem Upload verkleinern: 4000px-Originale (3-8 MB) braucht niemand,
// im Lager-WLAN zaehlt jede Sekunde. createImageBitmap richtet EXIF-Rotation automatisch
// aus ("from-image"); Fallback ueber <img>-Decode (Browser ab iOS 13.4/Chrome 81 rotieren
// dort selbst korrekt).

const JPEG_TYPE = "image/jpeg";

async function decode(file) {
  if (typeof createImageBitmap === "function") {
    try {
      return await createImageBitmap(file, { imageOrientation: "from-image" });
    } catch (e) {
      // z.B. aeltere Safari-Versionen ohne Options-Objekt -> Fallback
    }
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });
}

/**
 * Skaliert ein Bild auf maxEdge (laengste Kante) und kodiert als JPEG.
 * Liefert das Original zurueck, wenn es bereits klein genug ist oder die
 * Verarbeitung fehlschlaegt (Upload geht dann unkomprimiert raus).
 */
export async function compressImage(file, { maxEdge = 1600, quality = 0.8 } = {}) {
  try {
    const source = await decode(file);
    const width = source.width || source.naturalWidth;
    const height = source.height || source.naturalHeight;
    const scale = Math.min(1, maxEdge / Math.max(width, height));

    if (scale >= 1 && file.type === JPEG_TYPE && file.size < 600 * 1024) {
      if (source.close) source.close();
      return file;
    }

    const canvas = document.createElement("canvas");
    canvas.width = Math.round(width * scale);
    canvas.height = Math.round(height * scale);
    canvas.getContext("2d").drawImage(source, 0, 0, canvas.width, canvas.height);
    if (source.close) source.close();

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, JPEG_TYPE, quality));
    if (!blob) return file;

    const name = (file.name || "foto").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: JPEG_TYPE });
  } catch (e) {
    return file;
  }
}
